"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var PreviewCompatibleImage = function PreviewCompatibleImage(_ref) {
  var imageInfo = _ref.imageInfo;
  var imageStyle = {
    borderRadius: '5px'
  };
  var _imageInfo$alt = imageInfo.alt,
      alt = _imageInfo$alt === void 0 ? '' : _imageInfo$alt,
      childImageSharp = imageInfo.childImageSharp,
      image = imageInfo.image;

  if (!!image && !!image.childImageSharp) {
    return (
      /*#__PURE__*/
      _react["default"].createElement(_gatsbyImage["default"], {
        style: imageStyle,
        fluid: image.childImageSharp.fluid,
        alt: alt
      })
    );
  }

  if (!!childImageSharp) {
    return (
      /*#__PURE__*/
      _react["default"].createElement(_gatsbyImage["default"], {
        style: imageStyle,
        fluid: childImageSharp.fluid,
        alt: alt
      })
    );
  }

  if (!!image && typeof image === 'string') return (
    /*#__PURE__*/
    _react["default"].createElement("img", {
      style: imageStyle,
      src: image,
      alt: alt
    })
  );
  return null;
};

PreviewCompatibleImage.propTypes = {
  imageInfo: _propTypes["default"].shape({
    alt: _propTypes["default"].string,
    childImageSharp: _propTypes["default"].object,
    image: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]).isRequired,
    style: _propTypes["default"].object
  }).isRequired
};
var _default = PreviewCompatibleImage;
exports["default"] = _default;